<template>
  <v-dialog v-model="showLocalDialog" max-width="490">
    <v-card :loading="admin.productsLoading" :disabled="admin.productsLoading">
      <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
        Copy Product [{{ skuToCopy }}]
        <v-spacer></v-spacer>

        <v-icon>mdi-content-copy</v-icon>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-form>
          <v-text-field
            v-model="sku"
            outlined
            autofocus
            label="New Sku"
            required
          ></v-text-field>
          <v-checkbox
            v-model="includeAttributes"
            label="Include Attributes"
          ></v-checkbox>
          <v-checkbox
            v-model="includeAccessories"
            label="Include Accessories"
          ></v-checkbox>
          <v-checkbox
            v-model="includeRequirements"
            label="Include Requirements"
          ></v-checkbox>
          <v-checkbox
            v-model="includeSettings"
            label="Include Settings"
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" @click="copyProduct">Copy</v-btn>
        <v-btn color="gray" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      showDialog: Boolean,
      skuToCopy: String,
      productIdToCopy: Number
    },
    data() {
      return {
        showLocalDialog: this.showDialog,
        sku: '',
        includeAttributes: false,
        includeAccessories: false,
        includeRequirements: false,
        includeSettings: false
      };
    },
    watch: {
      showDialog(val) {
        this.showLocalDialog = val;
      },
      showLocalDialog(val) {
        this.$emit('close', val);
      }
    },
    methods: {
      copyProduct() {
        this.$store
          .dispatch('admin/copyProduct', {
            id: this.productIdToCopy,
            sku: this.sku,
            productId: this.productIdToCopy,
            includeAttributes: this.includeAttributes,
            includeAccessories: this.includeAccessories,
            includeRequirements: this.includeRequirements,
            includeSettings: this.includeSettings
          })
          .then((response) => {
            this.resetDialog();
            this.$store.dispatch('admin/getProductList').then(() => {
              this.selectProduct(response);
              this.$emit('showCopySuccess');
            });
          });
      },
      /**
       * Resets the dialog
       */
      resetDialog() {
        console.log('resetting dialog');
        this.sku = '';
        this.includeAttributes = false;
        this.includeAccessories = false;
        this.includeRequirements = false;
        this.includeSettings = false;
      },
      /**
       * Closes this dialog
       */
      closeDialog() {
        this.resetDialog();
        this.showLocalDialog = false;
      }
    },
    computed: {
      ...mapState(['admin'])
    }
  };
</script>
